import { useState, useEffect } from 'react'
import './index.css'
import { Col, Container, Row, Image } from 'react-bootstrap'

import { 
  hbuWhite,
  hbuColor 
} from '../../assets/image/index.js';

const Footer = () => {
  const [brand, setBrand] = useState(hbuWhite);
  

  return (
    <div className='hbu-footer align-items-center justify-content-center'>
    <Container >
        <Row>
            <Col >
                <div className="brand text-center ">
                    <Image className='img-brand' 
                    alt="HBU Express Logo"
                    src={brand} >

                    </Image>
                </div>
            </Col>
            <Col >
                <div className="copyright text-center ">
                    <p>© 2025 <span className='brand'>PT Humdi Berkah Utama.</span> All rights reserved.</p>
                </div>
            </Col>
            <Col >
                <div className="copyright text-center ">
                    <p>© 2025 <span className='brand'>PT Humdi Berkah Utama.</span> All rights reserved.</p>
                </div>
            </Col>
        </Row>
    </Container>
    </div>
  )
}

export default Footer